import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass('[&>*+[data-slot=control]]:mt-6 [&>[data-slot=text]]:mt-1')
}

import {
		provide
	} from 'vue'

	
	const __default__ = { name: 'VFieldset' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		disabled: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

const props = __props;

	

	provide('fieldsetDisabled', props.disabled)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})